const BASE_URL = window.ntApi;
const ROOT = window.ntPage.href;
const SINGLE_DEALER_ROOT = window.ntPage.singleDealerHref || window.ntPage.href;

export async function getDataFromApi(url, query = null) {
  const queryStr = query ? query.toString() : '';
  const response = await fetch(BASE_URL + url + (queryStr ? '?' + queryStr : ''), {
    method: 'GET',
    headers: {
      'X-Requested-With': 'xhr',
    },
  });

  let body = null;
  try {
    body = await response.json();
  }
  catch(e) {
    // Nothing to do
  }

  return {
    status: response.status,
    headers: response.headers,
    body,
  };
}

export {
  BASE_URL,
  ROOT,
  SINGLE_DEALER_ROOT,
}
